<app-question-card>
  <p question>
    Here are some basic home details. <br />
    <span class="fw-400 mt-1 d-block">Please update where necessary.</span>
  </p>
  <div question class="error-c mt-3" *ngIf="homeDetailsForm.invalid && showErrors">
    <lib-icon color="var(--red)" fontSize="14">info-filled</lib-icon>
    <p class="text-size-14 fw-500 m-0">Please enter correct values</p>
  </div>

  <div input-options>
    <form class="form-c" #homeDetailsForm="ngForm">
      <div class="home-field" *ngFor="let field of homeInfoFields">
        <div class="flex-box-center">
          <img [src]="'/assets/images/home-details/light/'+ field.icon +'.svg'" [alt]="field.icon" class="icon-img" />
          <p class="text-size-18 fw-600">{{ field.name }}</p>
        </div>
        <input
          type="number"
          [required]="field.required"
          [name]="field.name"
          [value]="field.value"
          [(ngModel)]="field.value"
          [max]="field.max ?? null"
          [min]="field.min ?? 0"
        />
      </div>
    </form>
  </div>

  <div answer>
    <div class="home-field c-pointer" *ngFor="let field of homeInfoFields">
      <div class="flex-box-center">
        <img [src]="'/assets/images/home-details/light/'+ field.icon +'.svg'" [alt]="field.icon" class="icon-img" />
        <p class="text-size-14 fw-500">{{ field.name }}</p>
      </div>
      <p class="text-size-16 fw-600">{{ field.value }}</p>
    </div>
  </div>
  <button class="w-100" footer (click)="homeDetailsForm.control.markAllAsTouched();showErrors = true;homeDetailsForm.valid && next()">
    Looks Good
  </button>
</app-question-card>
